import DevicesOverview from './DevicesOverview';

export default DevicesOverview;
